import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TLabelTicket } from '../types/label-ticket.type';

export const CreateLabelTicketValidationSchema = z.object({
  name: z.string().min(1),
  color: z.string().min(1),
});

export type TCreateLabelTicketValidation = z.infer<typeof CreateLabelTicketValidationSchema>;
export type TCreateLabelTicketPayload = TCreateLabelTicketValidation;
export type TCreateLabelTicketResponse = ApiResponse<TLabelTicket>;

export const createLabelTicket = async (payload: TCreateLabelTicketPayload): Promise<TCreateLabelTicketResponse> => {
  const url = '/label-ticket';

  return axiosInstance.post(url, payload);
};

/**
 * Use Create Label Ticket React-Query Hook
 */
type UseCreateLabelTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof createLabelTicket, AxiosErrorCustom>;
};

/**
 * Use Create Label Ticket React-Query Hook
 */
export const useCreateLabelTicketMutation = ({ mutationConfig }: UseCreateLabelTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: createLabelTicket,
    ...restConfig,
  });
};
